import Login from './Login.vue'
import HomeTab from './HomeTab.vue'
import RechargeTab from './RechargeTab.vue'
import RefundTab from './RefundTab.vue'
import FaqTab from './FaqTab.vue'
import ProfileTab from './ProfileTab.vue'

import i18nData from '@/i18n/locales.js'
import { packageList } from '@/data/packages.js'

export default {
  name: 'Main',
  components: {
    Login,
    HomeTab,
    RechargeTab,
    RefundTab,
    FaqTab,
    ProfileTab
  },
  data() {
    return {
      activeTab: 'home',
      homeSubPage: 'main',
      lang: localStorage.getItem('app_lang') || 'zh',
      isLoggedIn: !!localStorage.getItem('user_sn_code'),
      currentSn: localStorage.getItem('user_sn_code') || '',
      loginTime: localStorage.getItem('user_sn_login_time') || '',

      packageList,
      i18n: i18nData,

      dataPlan: {
        total: 100,
        used: 35.5,
        remaining: 64.5
      },

      orderHistory: [
        { id: 1, type: '在线充值 - 微信支付', amount: '100.00', date: '2026-09-08 14:20', status: '交易成功' },
        { id: 2, type: '在线充值 - 支付宝', amount: '50.00', date: '2026-08-15 09:11', status: '交易成功' }
      ]
    }
  },
  methods: {
    t(key) {
      const keys = key.split('.')
      let val = this.i18n[this.lang]
      for (const k of keys) {
        if (val && val[k] !== undefined) {
          val = val[k]
        } else {
          return key
        }
      }
      return val
    },

    toggleLanguage() {
      this.lang = this.lang === 'zh' ? 'en' : 'zh'
      localStorage.setItem('app_lang', this.lang)
    },

    switchTab(tab) {
      this.activeTab = tab
      if (tab === 'home') {
        this.homeSubPage = 'main'
      }
    },

    onLoginSuccess(sn) {
      const targetSn = sn || '123'
      const nowTime = new Date().toLocaleString()
      localStorage.setItem('user_sn_code', targetSn)
      localStorage.setItem('user_sn_login_time', nowTime)

      this.currentSn = targetSn
      this.loginTime = nowTime
      this.isLoggedIn = true
    },

    handleLogout() {
      localStorage.removeItem('user_sn_code')
      localStorage.removeItem('user_sn_login_time')
      this.currentSn = ''
      this.loginTime = ''
      this.isLoggedIn = false
      if (this.$message) {
        this.$message.success(this.t('msgLogout'))
      }
    }
  }
}